import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, CountryAutocompleteControl} from '../../../app/shared/classes';

export const NationalitySelector = 'nationality';
export const NationalitiesFormArraySelector = 'nationalitiesFormArray';

export const NationalityControl = (): BaseControl<number | string> => {
    return new CountryAutocompleteControl({
        name: NationalitySelector,
        value: null,
        placeholder: 'Nationality',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.CountryAutocomplete,
        options: [],
        countries: [],
        floatingLabelNever: true
    });
};
